import { Component, ErrorHandler, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/seguranca/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { Convenio } from 'src/app/model/Convenio';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  token: any;
  parceiros: any
  playLoad: any
  responsiveOptions: any
  
  filtro: string = '';
  convenios: Convenio[] = [];

  renovarLoginDialog = false;
  aguardeDialog = true;

  constructor(
    private dashboardService: DashboardService,
    private rota: ActivatedRoute,
    private erro: ErrorHandler,
    private auth: AuthService,
    private rotaNavegar: Router,
    private jwtDecoder: JwtHelperService,
    private toasty: ToastrService
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('access_token_xmanager');
    this.playLoad = this.jwtDecoder.decodeToken(this.token);
    this.buscarTodosParceiros();
    window.scrollTo(0,0);
  }

  conveniosFiltrados(): any[] {

        if (!this.filtro) {
            return this.convenios;
        }

        return this.convenios.filter(c =>
            c.dscConvenioFixo
                .toLowerCase()
                .includes(this.filtro.toLowerCase())
        );
    }

  buscarTodosParceiros() {
    if (!this.auth.isAccessTokenInvalido()) {
      this.aguardeDialog = true;
      this.dashboardService.buscarTodosParceiros(this.token).subscribe(
        (dados: any) => {
          this.convenios = dados;          
          this.aguardeDialog = false;
        },
        erro => {
          this.erro.handleError(erro);
          this.aguardeDialog = false;
        });
    } else {
      this.renovarLoginDialog = true;
    }
  }
}
